import { useQuery } from "@tanstack/react-query";
import type { District } from "@/lib/types";
import { API_BASE_URL } from "@/lib/api/config";

const fetchDistricts = async (): Promise<District[]> => {
  const response = await fetch(`${API_BASE_URL}/api/locations/districts`);
  if (!response.ok) {
    throw new Error("Failed to fetch districts");
  }
  const data = await response.json();
  return data.data.districts; // Adjust based on your actual API response structure
};

export const useDistricts = () => {
  return useQuery<District[], Error>({
    queryKey: ["districts"],
    queryFn: fetchDistricts,
    staleTime: Infinity, // Lookup data is generally static
    gcTime: Infinity,
  });
};
